import clsx from 'clsx'
import { Loader } from '@/components/Loader'
import { ButtonBase } from '../ButtonBase'
import { IButtonProps } from '../types'
import styles from './styles.module.scss'

const ButtonSecondary = ({ children, className, isLoading, ...props }: IButtonProps) => {
  return (
    <ButtonBase
      data-testid="mui-button-secondary"
      className={clsx(styles.secondary, className)}
      isLoading={isLoading}
      {...props}
    >
      {isLoading && <Loader />}
      {children}
    </ButtonBase>
  )
}

export default ButtonSecondary
